import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import { useHistory } from 'react-router-dom';
import { validateEmail } from '../../../utils/inputValidator';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import { generateEmailForRestoreMobile } from '../../actions/signinAction';

import styles from './index.pcss';

const cx = classNames.bind(styles);
const RestorePhoneNumber = props => {
  const {
    signInReducer,
    setShowVerifyEmail,
    generateEmailForRestoreMobile,
    generateCaptchaForRestoreMobile,
    flags
  } = props;
  const { requestId, captchaImage = '', success } = signInReducer;
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [captchaText, setCaptchaText] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const isExpired = urlParams.get('expired');

  useEffect(() => {
    gtmEventPush({
      event: 'pageload',
      page_type: 'restore your mobile number',
      page_name: 'restore your mobile number'
    });
    const emailId = history?.location?.state?.usernameObj?.emailId
      ? history?.location?.state?.usernameObj?.emailId
      : '';
    setEmail(emailId);
  }, []);

  const handleSubmit = () => {
    event.preventDefault();
    let isEmailValid = validateEmail(email);
    if (!isEmailValid) {
      const errormsg = 'Please enter valid email ID';
      setErrorMsg(errormsg);
      gtmEventPush({
        event: 'user_account_interactions',
        page_type: 'restore your mobile number',
        page_name: 'restore your mobile number',
        category: 'user account interactions',
        action: 'formError',
        label: errormsg
      });
    } else {
      let accCheckParams = { emailId: email.toLowerCase(), requestId, captchaCode: captchaText };
      generateEmailForRestoreMobile(accCheckParams, (checkResponse = {}) => {
        const { success, errorMessage = '' } = checkResponse;
        if (success) {
          gtmEventPush({
            page_name: 'restore your mobile number',
            page_type: 'restore your mobile number',
            event: 'user_account_interactions',
            category: 'user account interactions',
            action: 'restore your mobile number',
            label: 'restore'
          });
          setShowVerifyEmail(true);
        } else {
          const errormsg = errorMessage || 'Something went wrong please try again later';
          generateCaptchaForRestoreMobile(() => {});
          setErrorMsg(errormsg);
          gtmEventPush({
            page_name: 'restore your mobile number',
            page_type: 'restore your mobile number',
            event: 'user_account_interactions',
            category: 'user account interactions',
            action: 'formError',
            label: errormsg
          });
        }
      });
    }

    segmentEventPush({
      event:'Restore Form Filled',
      screen_name:'Restore Phone Number Screen'
    })
  };
  return (
    <div className={cx('restore-phonenumber-container')}>
      {isExpired && (
        <div className={cx('expired-link-msg')}>
          Oops! Your verification link has expired, please re-enter the details below to get another
          link
        </div>
      )}
      <div className={cx('header')}>Restore Phone number</div>
      <form className={cx('form-content')} onSubmit={handleSubmit}>
        <div className={cx('form-fields')}>
          <label>
            <input
              value={email}
              placeholder=" "
              type="input"
              maxLength="254"
              onChange={e => {
                setEmail(e.target.value);
                setErrorMsg('');
              }}
            />
            <span>Your Email Address</span>
            <div id="error-msg" className={cx('errormsg')}>
              {errorMsg}
            </div>
          </label>
        </div>
        {captchaImage !== '' && (
          <div className={cx('additional-verification')}>
            <div className={cx('header')}>Additional Verification</div>
            <div className={cx('captcha-container')}>
              <label className="label-pwd">
                {' '}
                Enter captcha
                <div>
                  <img
                    src={`data:image/png;base64, ${captchaImage}`}
                    className={cx('captcha-data')}
                    alt="Captcha Image"
                  />
                  <span
                    className="ic-easy-return"
                    onClick={() => {
                      setErrorMsg('');
                      generateCaptchaForRestoreMobile(() => {});
                    }}
                  />
                </div>
                <input
                  type="text"
                  className={cx('captcha-input')}
                  value={captchaText}
                  onChange={e => {
                    setCaptchaText(e.target.value);
                    setErrorMsg('');
                  }}
                />
              </label>
            </div>
          </div>
        )}
        <button
          type="submit"
          className={cx('restore-btn')}
          disabled={
            email?.length === 0 ||
            errorMsg?.length > 0 ||
            (email?.length > 0 && captchaImage.length != 0 && captchaText.length === 0)
          }
        >
          Restore
        </button>
      </form>
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    generateEmailForRestoreMobile: (data, callback) => {
      dispatch(generateEmailForRestoreMobile(data, callback));
    }
  };
};

export default connect(null, mapDispatchToProps)(RestorePhoneNumber);
